import { TRIGGER_CALENDAR_SYNC, RESET_CALENDAR_SYNC_TRIGGER } from '../../actions/Calendar/triggerCalendarSyncAction';

const initialState = {
    shouldSync: false
};

const calendarSyncTriggerReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRIGGER_CALENDAR_SYNC:
            return {
                ...state,
                shouldSync: true
            };
        case RESET_CALENDAR_SYNC_TRIGGER:
            return {
                ...state,
                shouldSync: false
            };
        default:
            return state;
    }
};

export default calendarSyncTriggerReducer;

